import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { Wishlist } from '@theme/wishlist';

/**
 * Header wishlist icon with an item-count bubble, mirroring how cart-icon.js reflects
 * the cart. Purely a live view of `Wishlist` state - all the actual logic lives there.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} count
 *
 * @extends {Component<Refs>}
 */
class WishlistIcon extends Component {
  requiredRefs = ['count'];

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(ThemeEvents.wishlistUpdate, this.#onWishlistUpdate);
    this.#render(Wishlist.getAll().length);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.wishlistUpdate, this.#onWishlistUpdate);
  }

  /** @param {import('@theme/events').WishlistUpdateEvent} event */
  #onWishlistUpdate = (event) => {
    this.#render(event.detail.productIds.length);
  };

  /** @param {number} count */
  #render(count) {
    this.refs.count.textContent = count > 99 ? '99+' : String(count);
    this.refs.count.classList.toggle('hidden', count === 0);
  }
}

if (!customElements.get('wishlist-icon')) {
  customElements.define('wishlist-icon', WishlistIcon);
}
